type TabListProps = {
    children: React.ReactNode
}

const TabList = (props: TabListProps) => {
    const { children } = props

    return <div className="flex space-x-5">{children}</div>
}

export default TabList
